import * as React from "react"

export const ArrowRightIcon = () => {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.71296 6.99999L1.70196 0.98999L0.287964 2.40399L4.88796 7.00399L0.287964 11.597L1.70196 13.011L7.71296 6.99999Z"
        fill="#1D1D1D"
      />
    </svg>
  )
}
